import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export const TermsConditions = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white py-24">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white/60 backdrop-blur-sm rounded-3xl p-12 border border-white/20 shadow-2xl"
        >
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-5xl font-black mb-6 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              {t('legal.terms_title')}
            </h1>
            <p className="text-slate-600 text-lg">
              {t('legal.last_updated')} {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="prose prose-slate max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.acceptance_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.acceptance_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.service_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.service_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.eligibility_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.eligibility_consumer')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.eligibility_adult')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.eligibility_minor')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.eligibility_coppa')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.account_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.account_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.content_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.content_ai')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.content_ownership')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.content_generated')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.content_restrictions')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.purchases_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.purchases_policy')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.purchases_refund')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.purchases_subscription')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.purchases_pricing')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.usage_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.usage_appropriate')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.usage_prohibited')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.usage_monitoring')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.usage_reporting')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.privacy_compliance')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.privacy_collection')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.privacy_children')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.privacy_security')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.liability_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.liability_warranty')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.liability_limitation')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.liability_damages')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.liability_content')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.termination_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.termination_user')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.termination_company')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.termination_data')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.termination_refund')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.modifications_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.modifications_notice')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.modifications_acceptance')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.modifications_rights')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.jurisdiction_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.jurisdiction_australian')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.jurisdiction_disputes')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.jurisdiction_international')}
                </p>
                <p className="text-slate-600 leading-relaxed">
                  {t('legal.jurisdiction_compliance')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.contact_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.contact_text')}
              </p>
            </section>

            <section className="border-t border-slate-200 pt-6">
              <p className="text-slate-500 text-sm italic">
                {t('legal.effective_date')}
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsConditions;